/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  // {
  //   url: '/',
  //   name: 'Home',
  //   slug: 'home',
  //   icon: 'HomeIcon'
  // },
  // {
  //   url: '/page2',
  //   name: 'Page 2',
  //   slug: 'page2',
  //   icon: 'FileIcon'
  // },
  {
    url: '/programs',
    name: 'Programs',
    slug: 'programs',
    icon: 'CopyIcon'
  },
  {
    name: 'Projects',
    slug: 'projects',
    icon: 'GridIcon',
    submenu: [
      {
        url: '/projects',
        name: 'Projects',
        slug: 'projects'
      },
      {
        url: '/projects/meetingAgenda',
        name: 'Meeting Agenda',
        slug: 'meeting-agenda'
      },
      {
        url: '/projects/nwtmeetingagenda',
        name: 'NWT Meeting Agenda',
        slug: 'nwt-meeting-agenda'
      },
      {
        url: '/projects/tpmmeetingagenda',
        name: 'TPM Meeting Agenda',
        slug: 'tpm-meeting-agenda'
      }
    ]
  },
  {
    url: '/properties',
    name: 'Properties',
    slug: 'properties',
    icon: 'MapPinIcon'
  },
  {
    name: 'Users',
    slug: 'users',
    icon: 'UserIcon',
    showBadge: true,
    submenu: [
      {
        url: '/users',
        name: 'Users',
        slug: 'users'
      },
      {
        url: '/users/unassigned',
        name: 'Unassigned Users',
        slug: 'unassigned-users',
        showBadge: true
      },
      {
        url: '/userlog',
        name: 'Log User Login',
        slug: 'userlog',
        showBadge: true
      }
    ]
  }
]
